<section>
    <div class="row">
        <div class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="input-group">
                <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Buscar">
                <input type="text" [(ngModel)]="request.nomeConvenio" id="txtSearchConvenio"
                    placeholder="Busque pelo nome do convênio" (input)="refresh()">
            </div>
        </div>
        <div class="col p-0 d-flex justify-content-end">
            <button class="btn primary-white-button" type="button" (click)="create()">
                Cadastrar novo convênio
                <i class="hgi hgi-stroke hgi-plus-sign-circle"></i>
            </button>
        </div>
    </div>
    <div *ngIf="pacienteConvenios.length > 0" class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Convênio</th>
                    <th>Plano</th>
                    <th>Número da carteira</th>
                    <th>Data de validade</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let pacienteConvenio of pacienteConvenios
                  | paginate
                    : {
                        id: 'convenioServer',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>{{pacienteConvenio.convenio.nomeFantasia ?? pacienteConvenio.convenio.razaoSocial}}</td>
                    <td>{{pacienteConvenio.plano}}</td>
                    <td>{{pacienteConvenio.numeroCarteira}}</td>
                    <td>{{pacienteConvenio.validade | date: "dd/MM/yyyy"}}</td>
                    <td>
                        <div class="d-flex row" *ngIf="pacienteConvenio.isActive; else desativado">
                            <button class="btn icon icon-edit" title="Editar" type="button" (click)="edit(pacienteConvenio)">
                                <i class="hgi hgi-stroke hgi-pencil-edit-02"></i>
                            </button>
                            <button class="btn icon icon-danger ml-2" type="button" title="Desativar"
                                (click)="activeOrDeActive(pacienteConvenio)">
                                <i class="hgi hgi-stroke hgi-toggle-off"></i>
                            </button>
                        </div>
                        <ng-template #desativado>
                            <button class="btn icon icon-dark-green ml-2" type="button" title="Ativar"
                                (click)="activeOrDeActive(pacienteConvenio)">
                                <i class="hgi hgi-stroke hgi-toggle-on"></i>
                            </button>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row" *ngIf="pacienteConvenios.length > 0">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="convenioServer" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>